import angular from 'angular';
import editDashboardModal from './editDashboardModal.html';

/* @ngInject */
export default function ($scope, AuthService, LayoutService, Dashboard, $uibModal, Reports, _) {
	$scope.loading = true;
	$scope.AuthService = AuthService;

	LayoutService.setTitle('Dashboard');

	const updateButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

	const editButton = LayoutService.getPageHeader()
	                                .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fas fa-edit"></i> Modify Dashboard</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
	             ]);

	$scope.editDashboard = () => {
		$uibModal.open({
			animation:                  true,
			template:                   editDashboardModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance, toastr, Dashboard, $state, $q) => {
				$scope.modalNewReport = {
					report:       null,
					layoutRow:    1,
					layoutColumn: 1,
				};

				$scope.modalDefaultNewReport = () => {
					let lastRow = 0;

					angular.forEach($scope.dashboardReports, (dashboardReport) => {
						lastRow = Math.max(lastRow, dashboardReport.layoutRow);
					});

					lastRow++;

					$scope.modalNewReport = {
						report:       null,
						layoutRow:    lastRow,
						layoutColumn: 1,
					};
				};

				$scope.modalRefresh = () => {
					$scope.modalDashboardReportsLoading = true;
					$scope.modalReportsLoading          = true;

					$q.all([
						  Dashboard.getList({
							  include: 'report',
						  }),
						  Reports.getList(),
					  ])
					  .then((results) => {
						  const dashboardReports = results[0];
						  const reports          = results[1];

						  $scope.modalDashboardReports = dashboardReports.sort((a, b) => {
							  if (a.layoutRow === b.layoutRow) {
								  return a.layoutColumn - b.layoutColumn;
							  }

							  return a.layoutRow - b.layoutRow;
						  });

						  $scope.modalReports = reports.sort((a, b) => {
							  return a.name.localeCompare(b.name);
						  });

						  $scope.modalDefaultNewReport();

						  $scope.modalDashboardReportsLoading = false;
						  $scope.modalReportsLoading          = false;
					  })
					  .catch((error) => {
						  toastr.clear();
						  toastr.error('There was an error loading dashboard reports', 'Error');

						  $uibModalInstance.close();
					  });
				};

				$scope.modalAddNewReport = () => {
					const dashboardReport = {
						report:       $scope.modalNewReport.report,
						layoutRow:    $scope.modalNewReport.layoutRow,
						layoutColumn: $scope.modalNewReport.layoutColumn,
					};

					if ($scope.validateModalData(dashboardReport)) {
						Dashboard.post(dashboardReport)
						         .then((response) => {
							         $scope.modalReloadDashboardReports();
							         $scope.modalDefaultNewReport();

							         toastr.clear();
							         toastr.success('Report pinned to dashboard. \n Refreshing list...', 'Pinned');
						         });
					}
				};

				$scope.validateModalData = (dashboardReport) => {
					if (dashboardReport.report === null) {
						toastr.clear();
						toastr.error('Please select a report.', 'Error');

						return false;
					}

					if (dashboardReport.layoutRow === '' || dashboardReport.layoutColumn === '') {
						toastr.clear();
						toastr.error('Please enter a layout row and column for the report.', 'Error');

						return false;
					}

					return true;
				};

				$scope.modalEditReport = (dashboardReport) => {
					// TODO: Add validation check

					Dashboard.one(dashboardReport.id)
					         .customPUT(dashboardReport)
					         .then((data) => {
						         toastr.clear();
						         toastr.success('The dashboard was updated successfully.', 'Success');
					         });
				};

				$scope.modalDeleteReport = (dashboardReport) => {
					Dashboard.one(dashboardReport.id)
					         .remove()
					         .then((response) => {
						         $scope.modalDashboardReports.splice($scope.modalDashboardReports.indexOf(dashboardReport), 1);
					         })
					         .catch((error) => {
						         toastr.clear();
						         toastr.error('There was an error while unpinning this report, please try again.', 'Error');
					         });
				};

				$scope.modalReloadDashboardReports = () => {
					$scope.modalDashboardReportsLoading = true;

					Dashboard.getList({
						         include: 'report',
					         })
					         .then((dashboardReports) => {
						         $scope.modalDashboardReports = dashboardReports.sort((a, b) => {
							         if (a.layoutRow === b.layoutRow) {
								         return a.layoutColumn - b.layoutColumn;
							         }
							         return a.layoutRow - b.layoutRow;
						         });

						         $scope.modalDashboardReportsLoading = false;
					         })
					         .catch((error) => {
						         toastr.clear();
						         toastr.error('There was an error loading dashboard reports.', 'Error');
					         });
				};

				$scope.modalClose = () => {
					$uibModalInstance.close();

					$scope.refresh();
				};

				$scope.modalRefresh();
			},
		});
	};

	$scope.refresh = () => {
		$scope.loading = true;

		Dashboard.getList({
			         include: 'report',
		         })
		         .then((data) => {
			         $scope.reports = data;

			         $scope.groupedReports = _.groupBy($scope.reports, (report) => {
				         return report.layoutRow;
			         });

			         $scope.loading = false;
		         });
	};

	LayoutService.getPageHeader()
	             .onClicked(updateButton, $scope.refresh);
	LayoutService.getPageHeader()
	             .onClicked(editButton, $scope.editDashboard);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/dashboard/controller.js